import { SiteUrls } from '@tableau/shared-urls';

// eslint-disable-next-line prettier/prettier
export class AppUrls extends SiteUrls { }
